import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import './snackbar.scss';

import OverflowTextTooltip from '../Text/OverflowTextTooltip';

interface SnackbarTextProps {
  wrapOnOverflow?: boolean;
  link?: string;
  text: string;
}

const SnackbarText: React.FC<SnackbarTextProps> = (props) => {
  const { wrapOnOverflow, link, text } = props;

  if (wrapOnOverflow && link) {
    return (
      <Link to={link} className="text-style-link">
        {text}
      </Link>
    );
  } else if (wrapOnOverflow) {
    return <p className="text-style-body">{text}</p>;
  } else {
    return (
      <OverflowTextTooltip
        text={text}
        link={link}
        textClassName={link ? 'text-style-link' : 'text-style-body'}
      />
    );
  }
};

export interface SnackbarProps {
  text: string;
  link?: string;
  wrapOnOverflow?: boolean;
  leftExtra?: JSX.Element;
  rightExtras?: JSX.Element | [JSX.Element] | [JSX.Element, JSX.Element];
  shouldFillContainer?: boolean;
}

// This component only handles the rendering of the snackbar itself.
// For placement on the screen, showing/hiding logic, etc. see components/adp/Snackbar.
const Snackbar: React.FC<SnackbarProps> = (props) => {
  const { text, leftExtra, rightExtras, link, wrapOnOverflow, shouldFillContainer } = props;
  return (
    <div
      className={classNames('dragonfruit-snackbar', {
        'should-fill-container': shouldFillContainer,
      })}
      aria-label="snackbar"
    >
      {leftExtra !== undefined && leftExtra !== null && (
        <div className="left-extra">{leftExtra}</div>
      )}
      <div className="text">
        <SnackbarText link={link} text={text} wrapOnOverflow={wrapOnOverflow} />
      </div>
      {rightExtras !== undefined && rightExtras !== null && (
        <div className="right-extras">{rightExtras}</div>
      )}
    </div>
  );
};

export default Snackbar;
